import { useEffect } from 'react';
export default function ClickOutsideComponentEvent(ref, callback) {
    useEffect(function () {
        // handle the click outside of the reference and call the callback.
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                callback();
            }
        }
        // Bind the event listener
        document.addEventListener('mousedown', handleClickOutside);
        return function () {
            // Unbind the event listener on clean up
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [ref]);
}
